import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { JsxElementType } from "@/utils/jsxElementTypes";
import { TempoElement } from "@/utils/tempoElement";
import { NavTreeNode, Storyboard } from "@/utils/types";
import { Code, ComponentIcon, Frame, X } from "lucide-react";
import React from "react";

interface ContextButtonProps {
  // If while selecting, these two are provided
  element?: TempoElement;
  navTreeNode?: NavTreeNode;

  // If from the chat message context, this is provided
  treeElementOrStoryboard?: JsxElementType | Storyboard | any;

  onClick?: () => void;
}

const ContextButton: React.FC<ContextButtonProps> = React.memo(
  ({ element, navTreeNode, onClick, treeElementOrStoryboard }) => {
    let Icon;
    let label;

    if (treeElementOrStoryboard) {
      if (treeElementOrStoryboard.isStoryboard) {
        Icon = Frame;
        label =
          treeElementOrStoryboard.type === "APPLICATION"
            ? "Route Storyboard"
            : treeElementOrStoryboard.name;
      } else if (
        treeElementOrStoryboard.type === JsxElementType.ComponentInstance ||
        treeElementOrStoryboard.type === JsxElementType.Component
      ) {
        Icon = ComponentIcon;
        label = treeElementOrStoryboard.componentName;
      } else {
        Icon = Code;
        label = treeElementOrStoryboard.jsxName?.toLowerCase();
      }
      // @ts-expect-error TS18048
    } else if (element.isStoryboard()) {
      Icon = Frame;
      label = "Storyboard";
    } else if (navTreeNode && navTreeNode.isComponent) {
      Icon = ComponentIcon;
      label = navTreeNode.name;
    } else if (navTreeNode) {
      Icon = Code;
      label = navTreeNode.name.toLowerCase();
    } else {
      Icon = Code;
      label = "Unknown";
    }

    return (
      <Button
        variant="ghost"
        size="sm"
        className={cn(
          "h-4 text-primary-n-500 bg-[#6448EF33] p-2 py-3 flex gap-1 text-3xs font-medium mb-0.5 cursor-pointer",
          "hover:text-primary-n-500 hover:bg-[#6448EF33]",
          !Boolean(onClick) && "pointer-events-none cursor-default"
        )}
        onClick={onClick}
      >
        <Icon className="stroke-primary-n-500 h-3 w-3" />
        <span>{label}</span>
        {element || navTreeNode ? (
          <X className="stroke-primary-n-500 h-3 w-3" />
        ) : null}
      </Button>
    );
  }
);

export default ContextButton;
